
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import './overchart.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, Title, Tooltip);

function OversChart() {
  const [oversData, setOversData] = useState({});
  const match_id = localStorage.getItem('match_id');
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`https://nammateam.onrender.com/oversall/summary/allovers/${match_id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setOversData(data.overs);
      })
      .catch(err => {
        console.error("Failed to fetch overs data", err);
        setOversData({});
      });
  }, [match_id]);

  // if (!oversData || Object.keys(oversData).length === 0) {
  //   return <p className="oc-loading">Loading overs chart...</p>;
  // }

  const overs = Object.keys(oversData).sort((a,b)=>a-b);
  const runs = overs.map(o => oversData[o].runs || 0);
  const wickets = overs.map(o => oversData[o].wickets || 0);
  const bowlerNames = overs.map(o => oversData[o].bowler || "");

  // Scatter dataset: only overs with wickets > 0
  const wicketPoints = overs.map((o, idx) => {
    const w = oversData[o].wickets || 0;
    if (w > 0) {
      return { x: idx, y: runs[idx], r: 6*w }; // size proportional to wickets
    }
    return null;
  }).filter(p => p !== null);

  const data = {
    labels: overs.map(o => `Ov ${parseInt(o)+1}`),
    datasets: [
      {
        label: "Runs",
        data: runs,
        backgroundColor: "rgba(37, 99, 235, 0.7)",
        borderRadius: 6,
      },
      {
        label: "Wickets",
        data: wicketPoints,
        type: "bubble",
        backgroundColor: "red",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            if(context.dataset.label === "Runs") {
              return `Runs: ${context.raw}, Wickets: ${wickets[context.dataIndex]}, Bowler: ${bowlerNames[context.dataIndex]}`;
            } else {
              const idx = context.dataIndex;
              return `Wickets: ${oversData[overs[idx]].wickets}, Over: Ov ${parseInt(overs[idx])+1}`;
            }
          }
        }
      },
      legend: { display: false },
    },
    scales: {
      x: { title: { display: true, text: "Overs" } },
      y: { title: { display: true, text: "Runs" }, beginAtZero: true, ticks: { stepSize: 2 } },
    },
  };

  return (
    <div className="oc-chart-container">
      <div className="oc-header">
        <button className="oc-back-btn" onClick={() => navigate("/live")}>← Back</button>
        <h2>Overs Runs Chart</h2>
      </div>
      <div style={{ marginTop: "60px" }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}

export default OversChart;
